import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from './Button.js';
import { StatusIcon } from './StatusIcon.js';
/**
 * Lima layar kondisi lintas modul (peta §5.9).
 *
 * Mereka hidup di `packages/ui` dan bukan disalin ke setiap layar, karena peta
 * memperlakukannya sebagai satu kontrak: kosong, memuat, gagal, modul di luar
 * paket, dan dialog konfirmasi berlaku LINTAS modul.
 */
/** `70:354` — kerangka, BUKAN pemintal, untuk tabel dan kartu. */
export function LoadingState({ rows = 5, label }) {
    return (_jsxs("div", { className: "assist-state assist-state--loading", role: "status", "aria-live": "polite", children: [_jsx("span", { className: "assist-sr-only", children: label }), Array.from({ length: rows }, (_, i) => (_jsx("div", { className: "assist-skeleton", style: { animationDelay: `${i * 90}ms` } }, i)))] }));
}
/**
 * `70:62` — koleksi kosong karena memang belum ada data.
 * SELALU membawa ajakan tindakan; kosong tanpa jalan keluar adalah jalan buntu.
 */
export function EmptyState({ title, body, action, icon, }) {
    return (_jsxs("div", { className: "assist-state assist-state--empty", children: [_jsx("div", { className: "assist-state__icon", children: icon ?? _jsx(StatusIcon, { kind: "information", size: 32 }) }), _jsx("h2", { className: "assist-state__title", children: title }), _jsx("p", { className: "assist-state__body", children: body }), action ? (_jsx(Button, { variant: "primary", onClick: action.onClick, children: action.label })) : null] }));
}
/**
 * `70:707` — galat jaringan atau server.
 * Tombol coba lagi + kode galat yang bisa DISEBUT ke dukungan. Bukan stack trace.
 */
export function ErrorState({ title, body, code, codeLabel, retryLabel, onRetry, }) {
    return (_jsxs("div", { className: "assist-state assist-state--error", role: "alert", children: [_jsx("div", { className: "assist-state__icon", children: _jsx(StatusIcon, { kind: "danger", size: 32 }) }), _jsx("h2", { className: "assist-state__title", children: title }), _jsx("p", { className: "assist-state__body", children: body }), code ? _jsx("p", { className: "assist-state__code", children: codeLabel ?? code }) : null, _jsx(Button, { variant: "primary", onClick: onRetry, children: retryLabel })] }));
}
/**
 * `70:1007` — `403 ENTITLEMENT_REQUIRED`.
 *
 * BUKAN halaman galat, dan itu perbedaan yang disengaja: modul yang tidak dibeli
 * bukan kerusakan. Layar ini menjelaskan modul apa dan SIAPA yang dapat
 * menyalakannya, karena pengguna yang melihatnya biasanya bukan orang yang
 * berwenang membelinya.
 */
export function ModuleNotInPlanState({ title, body, whoCanHelp, }) {
    return (_jsxs("div", { className: "assist-state assist-state--not-in-plan", children: [_jsx("div", { className: "assist-state__icon", children: _jsx(StatusIcon, { kind: "information", size: 32 }) }), _jsx("h2", { className: "assist-state__title", children: title }), _jsx("p", { className: "assist-state__body", children: body }), _jsx("p", { className: "assist-state__help", children: whoCanHelp })] }));
}
/**
 * Layar yang BELUM DIBANGUN — UAT D-07.
 *
 * Sebelumnya rute yang ada di navigasi tetapi layarnya belum ada memakai layar
 * `70:1007` ("Modul ini tidak ada di paket Anda") dengan badan berbahasa Indonesia
 * yang menyebut nama berkas repositori: `/users — belum dibangun pada gelombang
 * ini (lihat CATATAN-PENGEMBANG.md)`. Tiga hal salah sekaligus — alasannya salah
 * (M01 ADA di paket ESSENTIALS), kalimatnya hanya satu bahasa, dan ia ditujukan
 * kepada programmer.
 *
 * Komponen ini terpisah dari `ModuleNotInPlanState` justru supaya keduanya tidak
 * dapat tertukar lagi: yang itu menjawab `403 ENTITLEMENT_REQUIRED`, yang ini
 * menjawab "layarnya belum ada". Keduanya bukan halaman galat.
 */
export function ScreenNotBuiltState({ title, body, whoCanHelp, }) {
    return (_jsxs("div", { className: "assist-state assist-state--not-in-plan", children: [_jsx("div", { className: "assist-state__icon", children: _jsx(StatusIcon, { kind: "information", size: 32 }) }), _jsx("h2", { className: "assist-state__title", children: title }), _jsx("p", { className: "assist-state__body", children: body }), _jsx("p", { className: "assist-state__help", children: whoCanHelp })] }));
}
//# sourceMappingURL=states.js.map